import { Icon, Link, Text } from 'shell/components';

const LinkDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Link</Text>

            <Link to={'/404'}>Link</Link>
            <Link variant={'neutral'} to={'/404'}>
                Neutral Link
            </Link>
            <Link disabled to={'/404'}>
                Disabled Link
            </Link>

            <Link startIcon={<Icon kind={'add'} />} to={'/404'}>
                Link
            </Link>
            <Link startIcon={<Icon kind={'add'} />} variant={'neutral'} to={'/404'}>
                Neutral Link
            </Link>
            <Link disabled startIcon={<Icon kind={'add'} />} to={'/404'}>
                Disabled Link
            </Link>

            <Link endIcon={<Icon kind={'add'} />} to={'/404'}>
                Link
            </Link>
            <Link endIcon={<Icon kind={'add'} />} variant={'neutral'} to={'/404'}>
                Neutral Link
            </Link>
            <Link disabled endIcon={<Icon kind={'add'} />} to={'/404'}>
                Disabled Link
            </Link>
        </>
    );
};

export default LinkDemo;
